import {
  ACTION_GET_FLIGHT_BOOKING_WINDOW_FEATURE,
  ACTION_GET_FLIGHT_BOOKING_WINDOW_FEATURE_SUCCESS,
  ACTION_GET_FLIGHT_BOOKING_WINDOW_FEATURE_FAILURE,
  ACTION_PUT_FLIGHT_BOOKING_WINDOW_FEATURE,
  ACTION_PUT_FLIGHT_BOOKING_WINDOW_FEATURE_SUCCESS,
  ACTION_PUT_FLIGHT_BOOKING_WINDOW_FEATURE_FAILURE,
  ACTION_DELETE_FLIGHT_BOOKING_WINDOW_FEATURE,
  ACTION_DELETE_FLIGHT_BOOKING_WINDOW_FEATURE_SUCCESS,
  ACTION_DELETE_FLIGHT_BOOKING_WINDOW_FEATURE_FAILURE,
} from '../configs/ActionTypes';

import * as _ from 'lodash-es';

const initialState = {
  feature: [],
  isLoading: false,
  success: null,
};

export default function (state = initialState, action: any) {
  switch (action.type) {
    case ACTION_DELETE_FLIGHT_BOOKING_WINDOW_FEATURE:
    case ACTION_GET_FLIGHT_BOOKING_WINDOW_FEATURE:
    case ACTION_PUT_FLIGHT_BOOKING_WINDOW_FEATURE: {
      return {
        ...state,
        isLoading: true,
        success: null,
      };
    }

    case ACTION_GET_FLIGHT_BOOKING_WINDOW_FEATURE_SUCCESS:
    case ACTION_PUT_FLIGHT_BOOKING_WINDOW_FEATURE_SUCCESS: {
      return {
        ...state,
        feature: action.payload.payload,
        isLoading: false,
        success: true,
      };
    }

    case ACTION_DELETE_FLIGHT_BOOKING_WINDOW_FEATURE_SUCCESS: {
      return {
        ...state,
        feature: [],
        isLoading: false,
        success: true,
      };
    }

    case ACTION_GET_FLIGHT_BOOKING_WINDOW_FEATURE_FAILURE:
    case ACTION_PUT_FLIGHT_BOOKING_WINDOW_FEATURE_FAILURE:
    case ACTION_DELETE_FLIGHT_BOOKING_WINDOW_FEATURE_FAILURE: {
      return {
        ...state,
        isLoading: false,
        success: false,
      };
    }

    default: {
      return state;
    }
  }
}
